var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_message",on:{"click":_vm.close}},[_c('div',{staticClass:"popb"},[_c('div',{staticClass:"box b_fff pt37 pb40 pl40 pr40 tac"},[_c('img',{staticClass:"all96",attrs:{"src":require("@/assets/img/ok_h.png"),"alt":""}}),_vm._v(" "),_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7340a9d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message.vue
// module id = null
// module chunks = 